import { Box, Tab, Tabs, SxProps, Theme } from "@mui/material";
import { useState } from "react";
import QuerySetup from "./QuerySetup";
import { FormikProps } from "formik";
import { QuerySetpForm } from "../../TimeseriesPage";
import { FieldDataDefQuery } from "../../../../requests_cm/gecoReferentialService/types";

const style: { [key: string]: SxProps<Theme> } = {
	tab: {
		textTransform: "capitalize",

		"&.Mui-selected": {
			color: "black",
			fontWeight: 700,
		},
	},
	tabPanel: {
		backgroundColor: "white",
		minHeight: "400px",
	},
};

interface TabPanelProps {
	children?: React.ReactNode;
	sx?: SxProps<Theme>;
	index: number;
	value: number;
}
function CustomTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<Box
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			height={"90%"}
			{...other}
		>
			{value === index && (
				<Box sx={{ p: 3, height: "100%" }}>{children}</Box>
			)}
		</Box>
	);
}
interface QueryBuilderProps {
	formik: FormikProps<QuerySetpForm>;
	fielddataDefinitions?: FieldDataDefQuery[];
}

function QueryBuilder(props: QueryBuilderProps) {
	const { formik, fielddataDefinitions} = props;
	const [tabValue, setTabValue] = useState(0);

	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		setTabValue(newValue);
	};

	return (
		<Box sx={{ width: "100%", minHeight: "400px" }}>
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs
					value={tabValue}
					onChange={handleTabChange}
					aria-label="basic tabs example"
				>
					<Tab label="Query Setup" sx={style.tab} />
					<Tab
						label="Saved"
						sx={style.tab}
						disabled
					/>
					<Tab
						label="Shared"
						sx={style.tab}
						disabled
					/>
				</Tabs>
			</Box>
			<CustomTabPanel value={tabValue} index={0} sx={style.tabPanel}>
				<QuerySetup formik={formik} fielddataDefinitions={fielddataDefinitions} />
			</CustomTabPanel>
			<CustomTabPanel value={tabValue} index={1}>
				{"Saved Tab Panel"}
			</CustomTabPanel>
			<CustomTabPanel value={tabValue} index={2}>
				{"Shared"}
			</CustomTabPanel>
        {/*    TODO remove example code*/}
		</Box>
	);
}

export default QueryBuilder;
